import React, { Component } from 'react';
import { Row, Col, Input, Card, Table, Modal, Button, Spin, Radio, Upload, Icon, Skeleton, Avatar, Tooltip, Comment, List } from 'antd';
import './TicketCard.css';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { api } from '../../../../../services';
import { pick } from 'lodash';

const { TextArea } = Input;
const { confirm } = Modal;

@inject('translationsStore', 'commonStore')
@observer
export default class TicketCard extends Component {
  constructor(props) {
    super(props);
    const { translationsStore, commonStore } = props;
	this.columns = [
      {
        width: '110px',
        dataIndex: 'id',
        title: translationsStore.translate('carView.TicketCard.column.ticketId'),
        render: text => <span>{translationsStore.translate('carView.TicketCard.column.ticketIdDescription')}{Number(text).toLocaleString()}</span>
      },
	  {
        dataIndex: 'type',
        align: 'left',
        title: translationsStore.translate('carView.TicketCard.column.subject'),
        render: text => <span>{translationsStore.translate('carView.TicketCard.types.' + text)}</span>
	  },
	  {
        dataIndex: 'channel',
        align: 'center',
        title: translationsStore.translate('carView.TicketCard.column.channel'),
        render: text => <span>{translationsStore.translate('carView.TicketCard.channels.' + text)}</span>
	  },
	  {
        dataIndex: 'userName',
        align: 'left',
        title: translationsStore.translate('carView.TicketCard.column.author'),
        render: text => <span>{text}</span>
      },
      {
        dataIndex: 'createdAt',
        align: 'center',
        title: translationsStore.translate('carView.TicketCard.column.createdAt'),
		render: (text, record) => <span>{record.createdAt ? moment(record.createdAt).format(commonStore.longDateFormat.L) : '-'}</span>
      },
      {
        dataIndex: 'closedAt',
        align: 'center',
        title: translationsStore.translate('carView.TicketCard.column.closedAt'),
        render: (text, record) => <span>{record.closedAt ? moment(record.closedAt).format(commonStore.longDateFormat.L) : '-'}</span>
      },
	  {
        dataIndex: 'status',
        align: 'center',
        title: translationsStore.translate('carView.TicketCard.column.status'),
        render: text => <span>{translationsStore.translate('carView.TicketCard.statuses.' + text)}</span>
      }
    ];
	
    this.historyFetchMethods = [
      {
        key: 'tickets',
        method: 'getTicketsCarHistory',
        defaultSorter: { field: 'updatedAt', order: 'DESC' }
      }
    ];

    this.state = {
      sorters: { tickets: this.historyFetchMethods[0].defaultSorter },
	  isShowAll: false,
	  isCreateNew: false,
	  hasOpenTickets: null,
	  hasOpenTicketsClass: 'noOpenTickets',
	  typeId: null,
	  description: null,
	  fileList: [],
	  uploading: false,
	  creating: false,
	  types: ['DEFECTIVE_DEVICE', 'INCOMPATIBLE_DEVICE', 'INCORRECT_DATA', 'DIAGNOSTICS', 'ANTITHEFT', 'APP_CREDENTIALS', 'PORTABILITY', 'OTHER'],
	  statuses: ['OPEN', 'CLOSED'],
	  parentTicketId: null,
	  parentTicketLoaded: false,
	  ticketId: null,
	  ticket: { comments: [], files: [] },
	  showTicketDetail: false,
	  ticketDetailLoading: false,
	  comment: null
	};
  }

  componentDidUpdate(prevProps, prevState) {
	if (this.props.carId) {
		if (this.state.hasOpenTickets === null) {
			api('hasOpenTickets', this.props.carId).then(result => {
				this.setState({
				hasOpenTickets: result,
				hasOpenTicketsClass: (result ? '' : 'noOpenTickets'),
				});
			});
		}
	}
	if (prevState.parentTicketId !== this.state.parentTicketId && this.state.parentTicketId > 0 && this.state.parentTicketLoaded == false){
		this.loadTicketDetail(this.state.parentTicketId);
	}
  }

  static getDerivedStateFromProps(props, state) {
	if (props.ticketId !== state.parentTicketId && props.carId !== undefined) {
		return {
			parentTicketId: props.ticketId
		}
	}

    return null;
  }

  loadHistory = (methods = ['tickets'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };
  
  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };
  
  writeDescription = e => {
    this.setState({ description: e.target.value });
  };
  
  writeComment = e => {
    this.setState({ comment: e.target.value });
  };
  
  openTicketModal = () => {
	  this.setState({ isShowAll: true });
	  this.setState({ isCreateNew: false });
	  this.loadHistory();
  };
  
  onRadioButtonGroupChange = (e) => {
	  if (e.target.value == "showAll") {
		this.showTickets();
	  } else {
		this.showCreateTickets();
		this.resetCreateTicketModal();
	  }
  };
  
  showTickets = () => {
	  this.setState({ isShowAll: true, isCreateNew: false });
  }
  
  showCreateTickets = () => {
	  this.setState({ isShowAll: false, isCreateNew: true });
	  this.resetCreateTicketModal();
  }
  
  resetCreateTicketModal = () => {
	this.setState({ creating: false, typeId: null, description: null, fileList: [] });
  }
  
  onRadioTypeIdChange = e => {
    this.setState({
      typeId: e.target.value
    });
  };

  uploadFileCreate = file => {
	this.setState(state => ({
		fileList: [...state.fileList, file],
	  }));
	return false;
  };

  uploadFileRemove = file => {
	  const newFileList = [];
	  this.state.fileList.forEach(file => {
		  if (file.status !== 'removed') {
			newFileList.push(file);
		  }
	  });
	  this.setState(state => ({
		fileList: newFileList
	  }));
  };
  
  cancelCreateTicket = () => {
	const { translationsStore } = this.props;
	if (this.state.description === null && this.state.typeId === null) {
		this.showTickets();
	} else {
		let that = this;
		confirm({
			title: translationsStore.translate('carView.TicketCard.createNew.cancelCreateTicket.title'),
			content: translationsStore.translate('carView.TicketCard.createNew.cancelCreateTicket.content'),
			onOk() {
				that.showTickets();
			},
			onCancel() {},
		});
	}
  }

  createTicket = () => {
	this.setState({
		creating: true
	});
    api('createTicket', this.props.carId, this.state.typeId, this.state.description).then(result => {
      if (result.success === true) {
	    this.setState({
		  hasOpenTickets: true
		});
		if (this.state.fileList.length > 0) {
			let fileProcessed = 0;
			this.state.fileList.forEach(file => {
				let fileList = [];
				fileList.push(file);
				api('createTicketFile', this.props.carId, result.ticket.id, fileList).then(result => {
					fileProcessed++;
					if(fileProcessed === this.state.fileList.length) {
						this.createTicketCompleted();
					}
				});	
			});
		} else {
			this.createTicketCompleted();
		}
	  }
    });
  };

  createTicketCompleted = () => {
	this.setState({
		creating: false
	});
	this.loadHistory();
	this.showTickets();
  }
  
  hasOpenTickets = () => {
    api('hasOpenTickets', this.props.carId).then(result => {
      this.setState({
	    hasOpenTickets: result,
		hasOpenTicketsClass: (result ? '' : 'noOpenTickets')
	  });
    });
  };
  
  loadTicketDetail = (ticketId) => {
	  this.setState({ ticketDetailLoading: true, showTicketDetail: true, parentTicketLoaded: true });
	  api('getTicket', this.props.carId, ticketId)
	  .then(ticket => {
		this.setState({ ticketId: ticketId, ticket: ticket, ticketDetailLoading: false });
	  })
	  .catch(error => ({ error }))
	  .then(() => {
		//error
	  });
  }

  createComment = () => {
	api('createTicketComment', this.props.carId, this.state.ticketId, this.state.comment).then(result => {
	if (result.success === true) {
		this.resetComment();
		let ticket = this.state.ticket;
		ticket.comments.unshift(result.comment);
		this.setState({ ticket: ticket });
	}
	});
  };

  resetComment = () => {
	this.setState({ comment: null });
  };

  uploadFile = file => {
	this.setState({
		uploading: true,
	});
	let fileList = [];
	fileList.push(file);
	api('createTicketFile', this.props.carId, this.state.ticketId, fileList).then(result => {
		this.setState({
			uploading: false,
		});
		if (result.success === true) {
			let ticket = this.state.ticket;
			ticket.files.unshift(result.file);
			this.setState({ ticket: ticket, fileList: [] });
		}
		return false;
	});
	return false;
  };

  render() {
	const { translationsStore, commonStore } = this.props;
    const { sorters, historyActiveKey, uploading, fileList } = this.state;
    const columns = this.columns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });
    return (
	  <div className="TicketCard" style={this.props.style} id="TicketCard">
	    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', zIndex: '1000',  }}>
			<div className={this.state.hasOpenTicketsClass}>
			  <span className="hasOpenTickets">{this.props.translationsStore.translate('carView.TicketCard.hasOpenTickets')}</span>
			</div>
			<Button type="primary" onClick={this.openTicketModal}>
			 {this.props.translationsStore.translate('carView.TicketCard.viewTickets')}
			</Button>
		</div>
	    <Modal
		  title={translationsStore.translate('carView.TicketCard.title')}
		  width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.isShowAll}
          getContainer={() => document.getElementById('Carview')}
          footer={null}
          onCancel={() => this.setState({ isShowAll: false })}
		  centered={true}
		  className="ticketHistory"
		  zIndex="1000"
        >
        <div className="header" style={{ width: '100%', justifyContent: 'flex-end' }}>
			<Button type="primary" onClick={this.showCreateTickets}>
            	{translationsStore.translate('carView.TicketCard.createNew.labelCreate')}
            </Button>
        </div>
		<div>
			<Spin spinning={this.state.historyLoading}>
				{(this.state.historyResources || []).map(
				  (item, index) =>
					(
					  <Table
						id="TicketCardHistory"
						key={index}
						dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
						columns={this.columns}
						pagination={item.pagination}
						onChange={(...params) => this.handleTableChange(item.key, ...params)}
						rowClassName="historyRow"
						onRow={(record) => {
							return {
							  onClick: () => {
								this.setState({ ticketId: record.id });
								this.loadTicketDetail(record.id);
							  }
							};
						  }}
					  />
					)
				)}
			</Spin>
		</div>
		</Modal>
		<Modal
		  title={translationsStore.translate('carView.TicketCard.createNew.title')}
		  width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.isCreateNew}
          getContainer={() => document.getElementById('Carview')}
          footer={null}
          onCancel={this.cancelCreateTicket}
		  centered={true}
		  className="ticketCreate"
		  zIndex="1000"
        >
		<div>
		  <Row className="body">
		    <Col span={12}>
			  <div style={{ padding: '10px' }}>
				<div><strong className="label">{translationsStore.translate('carView.TicketCard.createNew.typeLabel')}</strong></div>
				<Radio.Group onChange={this.onRadioTypeIdChange} value={this.state.typeId} className="radioGroupType">
					{
						this.state.types.map((item, index) =>
						(
						<Radio key={index} value={item} style={{ display: 'block', height: '25px' }}>
						{translationsStore.translate('carView.TicketCard.types.' + item)}
						</Radio>
						))
					}
				</Radio.Group>
			  </div>
            </Col>
            <Col span={12}>
			  <div style={{ padding: '10px' }}>
				<TextArea
					onChange={this.writeDescription}
					value={this.state.description}
					placeholder={translationsStore.translate('carView.TicketCard.createNew.descriptionPlaceholder')}
					autosize={{ minRows: 5 }}
					resize="true"
				/>
				<div>
					<strong className="label">{translationsStore.translate('carView.TicketCard.createNew.upload.label')}</strong>
					<br/>
					<Upload
						name="file"
						beforeUpload={this.uploadFileCreate}
						onRemove={this.uploadFileRemove}
						fileList={fileList}
					>
						<Button>
							<Icon type="upload" /> {translationsStore.translate('carView.TicketCard.createNew.upload.placeholder')}
						</Button>
					</Upload>
				</div>
			  </div>
            </Col>
          </Row>
          <Row className="footer" type="flex" justify="center" align="middle">
            <Col>
              <Button type="primary" disabled={!this.state.description || this.state.description.length === 0 || !this.state.typeId || this.state.typeId == '' } onClick={this.createTicket}>
				<Icon type="loading" className={!this.state.creating ? 'hidden': null } /> {translationsStore.translate('carView.TicketCard.createNew.save')}
              </Button>
            </Col>
          </Row>
		</div>
		</Modal>
		<Modal
		  title={(this.state.ticket !== null) ? (<span>{translationsStore.translate('carView.TicketCard.detail.ticketNo')}{this.state.ticket.id}</span>) : ('') }
		  width="calc(var(--tablet-width) / var(--modal-width-ratio))"
		  visible={this.state.showTicketDetail}
		  getContainer={() => document.getElementById('Carview')}
          footer={null}
          onCancel={() => this.setState({ ticketId: null, showTicketDetail: false, ticket: { comments: [], files: [] } })}
          centered={true}
		  className="ticketDetail"
		  zIndex="2000"
        >
		<div style={{ display: 'flex', width: '100%' }}>
		 <Card style={{ width: '100%' }} bordered={false}>
		  <Skeleton loading={this.state.ticketDetailLoading}>
		  <Row className="body" style={{ display: 'flex', width: '100%' }}>
			<Col span={12}>
			  <div>
				<Col span={12}>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.status')}</strong>
				</Col>
				<Col span={12}>
				  {translationsStore.translate('carView.TicketCard.statuses.' +  this.state.ticket.status)}
				</Col>
			  </div>
			  <div className="separator">
				<Col span={12}>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.dateCreated')}</strong>
				</Col>
				<Col span={12}>
				  {this.state.ticket.createdAt ? moment(this.state.ticket.createdAt).format(commonStore.longDateFormat.L) : '-'}
				</Col>
			  </div>
			  <div className="separator">
				<Col span={12}>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.dateAssigned')}</strong>
				</Col>
				<Col span={12}>
				  {this.state.ticket.assignedAt ? moment(this.state.ticket.assignedAt).format(commonStore.longDateFormat.L) : '-'}
				</Col>
			  </div>
			  <div className="separator">
				<Col span={12}>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.dateClosed')}</strong>
				</Col>
				<Col span={12}>
				  {this.state.ticket.closedAt ? moment(this.state.ticket.closedAt).format(commonStore.longDateFormat.L) : '-'}
				</Col>
			  </div>
			  <div className="separator">
				<Col>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.type')}</strong>
				</Col>
				<Col>
				  {translationsStore.translate('carView.TicketCard.types.' +  this.state.ticket.type)}
				</Col>
			  </div>
			  <div className="separator">
				<Col>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.description')}</strong>
				</Col>
				<Col>
				  {this.state.ticket.description}
				</Col>
			  </div>
			  <div className="separator">
			  <strong>{translationsStore.translate('carView.TicketCard.detail.attachments') + ' (' + this.state.ticket.files.length + ')'}</strong>
				{(this.state.ticket !== null && this.state.ticket.files !== undefined) ? 
					<List
						className="files-list"
						dataSource={this.state.ticket.files || []}
						renderItem={file => (
							<li style={{ display: 'inline-block', paddingRight: '10px'}}>
							  <a href={file.file} target="_blank" rel="noopener noreferrer">
							  	<Icon type="paper-clip" />
							  	{file.fileName}
							  </a>
							</li>
						  )}
					>
					</List> 
					 : "" }
					<Row style={{ paddingTop: '10px'}}>
						<Col span={24}>
							<Upload
								name="file"
								beforeUpload={this.uploadFile}
							>
								<Button disabled={uploading ? 1 : 0} style={{ height: '34px' }}>
								<Icon type={uploading ? 'loading' : 'upload'} /> {translationsStore.translate('carView.TicketCard.detail.upload.placeholder')}
								</Button>
							</Upload>
						</Col>
					</Row>
				</div>
			  {(this.state.ticket.solution !== null) ? (
				<div className="separator">
				<Col style={{ color: '#4ec885'}}>
				  <strong>{translationsStore.translate('carView.TicketCard.detail.closed')}</strong>
				</Col>
				<Col>
					{this.state.ticket.solution}
				</Col>
				</div>
			  ) : (
				<div />
			  )}
			</Col>
			<Col span={12}>
			  <div>
				<Card title={translationsStore.translate('carView.TicketCard.detail.comments') + ' (' + this.state.ticket.comments.length + ')'} headStyle={{backgroundColor: '#38aea6', border: 0, color: '#fff' }} bordered={false}>
				  {(this.state.ticket !== null && this.state.ticket.comments !== undefined) ? 
					<List
						className="comments-list"
						itemLayout="horizontal"
						dataSource={this.state.ticket.comments || []}
						renderItem={comment => (
							<li>
							  <Comment
								avatar={
									<Avatar
									style={{ backgroundColor: (comment.dealerId === null) ? '#87d068' : '#faad14' }}
									alt={(comment.dealerId === null) ? 'AIR' : 'IO'}
									>{(comment.dealerId === null) ? 'AIR' : 'IO'}</Avatar>
								}
								content={
									<p>
									{comment.description}
									</p>
								}
								datetime={
									<Tooltip title={moment(comment.createdAt).format('YYYY-MM-DD HH:mm:ss')}>
									<span>{moment(comment.createdAt).fromNow()}</span>
									</Tooltip>
								}
								/>
							</li>
						  )}
					>
					</List> 
					 : "" }
				  <Row style={{ paddingTop: '10px'}}>
				   <Col span={20}>
					  <Input
						value={this.state.comment}
						onChange={this.writeComment}
						placeholder={translationsStore.translate('carView.TicketCard.detail.comment.placeholder')}
					  />
				   </Col>
				   <Col span={4}>
				    <Button disabled={!this.state.comment || this.state.comment.length === 0} onClick={this.createComment}>
					 {translationsStore.translate('carView.TicketCard.detail.comment.send')}
					</Button>
				   </Col>
				  </Row>
				</Card>
			  </div>
			</Col>
		  </Row>
		  </Skeleton>
		  </Card>
		</div>
		</Modal>
      </div>
    );
  }
}
